import { DASHBOARD_SUBSCRIPTION_HELPCENTER_URL } from '@modules/dashboard/constants';
import { Box, Link, Typography } from '@mui/material';

export const DashboardSubscribeDrawerContentHeader = () => {
  return (
    <Box p={2}>
      <Typography color="text.secondary" component="span" variant="body2">
        Subscribing to a dashboard will deliver a PDF report, which is a
        snapshot of all the widgets added in it.{' '}
      </Typography>
      <Link
        href={DASHBOARD_SUBSCRIPTION_HELPCENTER_URL}
        variant="body2"
        target="_blank"
        rel="noreferrer"
      >
        Learn More
      </Link>
    </Box>
  );
};
